import { Box, Typography } from '@mui/material'
import SystemSolutionsCard from 'src/components/SystemSolutions/SystemSolutionsCard'
import { developedSoftwares } from 'src/components/SystemSolutions/enums'

const SystemSolutions = () => {
  return (
    <Box
      sx={{
        py: 5,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="500"
        sx={{
          mb: 5,
          textAlign: 'center',
          borderBottom: `2px solid #000`,
          width: 'fit-content',
          mx: 'auto',
        }}
      >
        System software developed
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {developedSoftwares.map((developedSoftware, index) => (
          <SystemSolutionsCard {...developedSoftware} key={index} />
        ))}
      </Box>
    </Box>
  )
}

export default SystemSolutions
